import React from "react";
import { cn } from "utils/helpers";

type MenuTermsPropsType = {
	className?: string;
};

export default function MenuTerms() {
	return (
		<div className="ml-10 pb-2 text-xs text-fq-quinary-400">
			<div className="flex gap-6 mb-2">
				<a
					href=" https://www.procuracon.com.au/"
					target="_blank"
					rel="noreferrer"
					className="text-fq-quinary-400"
				>
					About Procuracon
				</a>
				<TermsAndConditionLink />
			</div>
			<PrivacyPolicyLink />
		</div>
	);
}

export const TermsAndConditionLink: React.FC<MenuTermsPropsType> = ({
	className,
}) => {
	return (
		<a
			href="https://procuracon.com.au/terms-conditions"
			target="_blank"
			rel="noreferrer"
			className={cn("text-fq-quinary-400", className)}
		>
			Terms & Conditions
		</a>
	);
};

export const PrivacyPolicyLink: React.FC<MenuTermsPropsType> = ({
	className,
}) => {
	return (
		<a
			href="https://procuracon.com.au/privacy-policy"
			target="_blank"
			rel="noreferrer"
			className={cn("text-fq-quinary-400", className)}
		>
			Privacy Policy
		</a>
	);
};
